import React from 'react';
import classNames from 'classnames';
import { STATUS_CLASS } from './ComboBoxClasses';

interface ScreenReaderTextProps {
  showList: boolean;
  filteredOptionsLength: number;
  assistiveHintID: string;
  ariaHidden: boolean;
}

const ScreenReaderText = ({
  showList,
  filteredOptionsLength,
  assistiveHintID,
  ariaHidden,
}: ScreenReaderTextProps): JSX.Element => {
  let statusMessage;
  if (showList) {
    statusMessage =
      filteredOptionsLength > 0
        ? `${filteredOptionsLength} result${filteredOptionsLength > 1 ? 's' : ''} available.`
        : 'No results.';
  } else {
    statusMessage = null;
  }
  return (
    <>
      <div className={classNames(STATUS_CLASS, 'usa-sr-only')} role="status">
        {statusMessage}
      </div>
      <span id={assistiveHintID} className="usa-sr-only" aria-hidden={ariaHidden}>
        When autocomplete results are available use up and down arrows to review and enter to select. Touch device
        users, explore by touch or with swipe gestures.
      </span>
    </>
  );
};

export default ScreenReaderText;
